import { useState } from "react";
import { Tabs, Card, Row, Col, Switch, Input, Collapse } from "antd";
import { BaseSelect } from 'components/Elements';
import RateSettingsForm from "./RateSettingsForm";
import CarrierTable from "./CarrierTable";
// styles
import 'assets/styles/shipment.scss';

const { TabPane } = Tabs;
const { Panel } = Collapse;

const StorefrontClassificationSettingForm = (props) => {
    const { platform, data, orderTypes, modes, cartTotalOptions, onChange } = props;

    const [orderType, setOrderType] = useState('prepaid');
    const [mode, setMode] = useState('air');

    return (
        <div>
            <Row className='mb-16' gutter={[32, 32]}>
                <Col xs={24} sm={24} md={12} lg={12}>
                    <Row justify="space-between" align="middle">
                        <label>Default order type</label>
                        <Col xs={12} sm={12} md={12} lg={12}>
                            <BaseSelect
                                className="w-100"
                                options={orderTypes}
                                value={data?.default_order_type}
                                onChange={(value) => onChange(`${platform}.storefront.default_order_type`, value)}
                            />
                        </Col>
                    </Row>
                </Col>
                <Col xs={24} sm={24} md={12} lg={12}>
                    <Row justify="space-between" align="middle">
                        <label>Default mode type</label>
                        <Col xs={12} sm={12} md={12} lg={12}>
                            <BaseSelect
                                className="w-100"
                                options={modes}
                                value={data?.default_mode}
                                onChange={(value) => onChange(`${platform}.storefront.default_mode`, value)}
                            />
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Row className='mb-16' align="middle" gutter={[32, 32]}>
                <Col xs={24} sm={24} md={12} lg={12}>
                    <Row justify="space-between" align="middle">
                        <label>Showing estimated delivery date at checkout</label>
                        <Switch
                            checked={data?.showing_estimated_date}
                            onChange={(checked) => onChange(`${platform}.storefront.showing_estimated_date`, checked)}
                        />
                    </Row>
                </Col>
                <Col xs={24} sm={24} md={12} lg={12}>
                    <Row justify="space-between" align="middle">
                        <label>Cart total based on</label>
                        <Col xs={12} sm={12} md={12} lg={12}>
                            <BaseSelect
                                className="w-100"
                                options={cartTotalOptions}
                                value={data?.cart_total_based_on}
                                onChange={(value) => onChange(`${platform}.storefront.cart_total_based_on`, value)}
                            />
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Tabs className="mt-16" defaultActiveKey={orderType} onChange={setOrderType}>
                <TabPane tab="Prepaid orders" key='prepaid'></TabPane>
                <TabPane tab="Offline orders (COD)" key='cod'></TabPane>
                {/* <TabPane tab="Pay on Delivery (CCOD)" key='ccod'></TabPane> */}
            </Tabs>

            <div>
                <Row gutter={[32, 32]} align="middle">
                    <Col xs={24} sm={24} md={12} lg={12}>
                        <Row justify="space-between" align="middle">
                            <label>Allow this shipment type</label>
                            <Switch
                                checked={data?.[orderType]?.status}
                                onChange={(checked) => onChange(`${platform}.storefront.${orderType}.status`, checked)}
                            />
                        </Row>
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12}>
                        <Row justify="space-between" align="middle">
                            <label>Name to display at checkout</label>
                            <Col xs={12} sm={12} md={12} lg={12}>
                                <Input
                                    value={data?.[orderType]?.name}
                                    onChange={(e) => onChange(`${platform}.storefront.${orderType}.name`, e.target.value)}
                                />
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <div className='mb-16'>
                    <div>
                        <span className='mr-16'>Use smart rates</span>
                        <Switch
                            size='small'
                            checked={data?.[orderType]?.enable_smart_rates}
                            onChange={(checked) => onChange(`${platform}.storefront.${orderType}.enable_smart_rates`, checked)}
                        />
                    </div>
                    <BaseSelect
                        className='w-100 mt-8'
                        placeholder="Smart rate mode"
                        options={[
                            { value: 'lowest_cost_each_mode', label: 'Show lowest cost for each mode' },
                            { value: 'lowest_cost_all_mode', label: 'Show lowest cost amongst all modes' },
                        ]}
                        value={data?.[orderType]?.smart_rates_mode}
                        onChange={(value) => onChange(`${platform}.storefront.${orderType}.smart_rates_mode`, value)}
                    />
                </div>
            </div>

            <Card className="mt-24">
                <Tabs defaultActiveKey={mode} onChange={setMode}>
                    <TabPane tab="Air" key='air'></TabPane>
                    <TabPane tab="Surface" key='surface'></TabPane>
                </Tabs>

                <div>
                    <Row gutter={[32, 32]} align="middle" className="mb-16">
                        <Col xs={24} sm={24} md={12} lg={12}>
                            <Row justify="space-between" align="middle">
                                <label>Allow this shipment type</label>
                                <Switch
                                    checked={data?.[orderType]?.[mode]?.status}
                                    onChange={(checked) => onChange(`${platform}.storefront.${orderType}.${mode}.status`, checked)}
                                />
                            </Row>
                        </Col>
                        <Col xs={24} sm={24} md={12} lg={12}>
                            <Row justify="space-between" align="middle">
                                <label>Name to display at checkout</label>
                                <Col xs={12} sm={12} md={12} lg={12}>
                                    <Input
                                        value={data?.[orderType]?.[mode]?.name}
                                        onChange={(e) => onChange(`${platform}.storefront.${orderType}.${mode}.name`, e.target.value)}
                                    />
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row justify="space-between" align="middle" className="mb-16" >
                        <label>Set range to show this shipment option at the checkout</label>
                        <Col xs={12} sm={12} md={12} lg={12}>
                            <Row gutter={16}>
                                <Col xs={12} sm={12} md={12} lg={12}>
                                    <Input
                                        value={data?.[orderType]?.[mode]?.min_cart_total}
                                        placeholder="Minimal cart total"
                                        onChange={(e) => onChange(`${platform}.storefront.${orderType}.${mode}.min_cart_total`, e.target.value)}
                                    />
                                </Col>
                                <Col xs={12} sm={12} md={12} lg={12}>
                                    <Input
                                        value={data?.[orderType]?.[mode]?.max_cart_total}
                                        placeholder="Maximum cart subtotal"
                                        onChange={(e) => onChange(`${platform}.storefront.${orderType}.${mode}.max_cart_total`, e.target.value)}
                                    />
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </div>

                <Collapse accordion>
                    <Panel header="Carrier settings" key="carrier">
                        <CarrierTable
                            platform={platform}
                            orderType={orderType}
                            mode={mode}
                            data={data?.[orderType]?.[mode]?.exclude_carriers || {}}
                            onChange={onChange}
                        />
                    </Panel>
                    <Panel header="Rate settings" key="rate">
                        <RateSettingsForm
                            platform={platform}
                            orderType={orderType}
                            mode={mode}
                            data={data?.[orderType]?.[mode]?.rate || {}}
                            onChange={onChange}
                        />
                    </Panel>
                </Collapse>
            </Card>
        </div>
    )
};

export default StorefrontClassificationSettingForm;
